export default "__VITE_ASSET__833fb95b__"